<script lang="ts">
	import Formatted from "@components/common/Formatted.svelte";
	import type { Snippet } from "svelte";
	import type { ClassValue } from "svelte/elements";
	import { idFromAnchor } from "@core/schema/utils/idFromAnchor.js";

	const {
		heading,
		children,
		media,
		class: customClass,
		mediaClass,
		imageLeft,
		anchor,
	}: {
		heading: string | Snippet;
		children?: Snippet;
		media?: Snippet;
		class?: ClassValue;
		mediaClass?: ClassValue;
		imageLeft?: boolean;
		anchor?: string;
	} = $props();
</script>

<section class={["md:grid-container full-width py-23.5 overflow-hidden", customClass]} id={idFromAnchor(anchor)}>
	<div
		class={[
			"flex items-center flex-col px-4 md:px-0 gap-10 md:gap-15 lg:gap-38",
			imageLeft ? "md:flex-row-reverse" : "md:flex-row",
		]}
	>
		<div class="flex flex-col gap-16">
			{#if typeof heading === "string"}
				<div class="text-black font-antipol font-bold text-9/tighter">
					<Formatted text={heading} />
				</div>
			{:else}
				{@render heading()}
			{/if}
			<div class="font-light text-5 grow">
				{@render children?.()}
			</div>
		</div>
		<div class={["relative grow-0 shrink-0 w-93 h-100 md:h-140 max-w-full", mediaClass]}>
			{@render media?.()}
		</div>
	</div>
</section>
